import React, { useState, useContext, useEffect } from 'react';
import { UserContext } from '../../contexts/userContext';
import request from '../../../services/Request';
import MaterialTable from 'material-table';
import BackButton from '../../items/buttons/BackButton';
import LoadingIcon from '../../items/buttons/LoadingIcon';
import {
  FormControlLabel,
  RadioGroup,
  Grid,
  Radio,
  TextField,
  Checkbox,
  Button,
  Container,
} from '@material-ui/core';

import { userLimits } from '../../dashboard/uitls/userLimits';
import moment from 'moment';
import { localDateRange } from '../../../services/method/methods';
import { makeStyles } from '@material-ui/core';
import DateFnsUtils from '@date-io/date-fns';
// ----------------------------------------------------------------------
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import { Autocomplete } from '@material-ui/lab';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { esES } from '@mui/x-data-grid';
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 140,
  },
  buttom: {
    width: 80,
    height: 40,
    marginTop: 15,
  },
}));

Date.prototype.toShortFormat = function () {
  let monthNames = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];

  let day = this.getDate();

  let monthIndex = this.getMonth();
  let monthName = monthNames[monthIndex];

  let year = this.getFullYear();

  return `${day}-${monthName}-${year}`;
};

export default function DownloadSales(props) {
  const { userEmail, filterd, setFiltered } = useContext(UserContext);
  const classes = useStyles();
  //start at first date of this month
  var date = new Date();
  const [startDate, setStartDate] = useState(new Date(date.getFullYear(), date.getMonth(), 1));
  const [endDate, setEndDate] = useState(new Date());
  const [order, setOrder] = useState([]);
  const [machines, setMachines] = useState([]);
  const [machineName, setMachineName] = useState('All Machines');
  const [loading, setLoading] = useState(false);
  const [groups, setGroups] = useState([]);
  const [groupV, setgroupV] = useState([]);
  const [radio, setRadio] = useState('a');
  const user = JSON.parse(localStorage.getItem('user'));

  // console.log(user);
  const { id, tableTitle, superAdmin } = userLimits(
    props.match.params.id,
    props.match.params.group,
    'Transactions',
    'view_trans'
  );

  const getAllEmployeesURL = `/users/getAllEmployees`;
  useEffect(() => {
    let isCancelled = false;

    //getAllEmployees
    async function getAllEmployees() {
      await request({
        method: 'get',
        url: getAllEmployeesURL,
      })
        .then((res) => {
          if (!isCancelled) {
            setGroups(res.data);
            setLoading(true);
            console.log('all admin', res.data);
          }
        })
        .catch((err) => {
          setLoading(true);
        });
    }

    getAllEmployees();

    return () => {
      isCancelled = true;
    };
  }, []);
  const handleStartDate = (e) => {
    setStartDate(e);
  };

  const handleEndDate = (e) => {
    setEndDate(e);
  };

  const handleRowUpdate = (newData, oldData) => {
    const installed_date = newData?.installed_date;
    console.log('row installed_date', newData);
    // const dataUpdate = [...data];
    // const index = oldData.tableData.id;
    request({
      method: 'post',
      url: `/machines/updateInstallDateForMachine`,
      data: {
        machineID: newData.MachineID,
        installed_date: installed_date,
      },
    })
      .then((res) => {
        setOrder((pres) =>
          pres.map((e) =>
            e.MachineID === newData.MachineID ? { ...e, installed_date: newData.installed_date } : e
          )
        );
      })
      .catch((err) => {
        setLoading(true);
      });

    // dataUpdate[index] = newData;
    // setData([...dataUpdate]);
    // Here you would typically also make an API call to update the data on the server
  };

  const handleSearch = async (event) => {
    if (radio === 'a') {
      setLoading(false);
      const { startDateString, endDateString } = localDateRange(startDate, endDate);
      await request({
        method: 'post',
        url: `/downloadSalesForShiva`,
        data: {
          startDate: startDateString,
          endDate: endDateString,
          id: id,
        },
      }).then(async (res) => {
        res.data.forEach((mc) => {
          //check mc.belongTo from groups
          const index = groups.findIndex((e) => e.email === mc.belongTo);
          if (index !== -1) {
            mc.groupCode = groups[index].groupCode.toUpperCase();
          }
        });
        console.log('received', res.data);
        setOrder(res.data);
        setLoading(true);
      });
    }
  };
  let columns = [
    { title: 'Machine ID', field: 'MachineID', editable: 'never' },
    { title: 'Sales', field: 'Sales', editable: 'never' },
    { title: 'Client', field: 'groupCode', editable: 'never' },
    { title: 'Installed Date', field: 'installed_date' },
  ];

  return (
    <div>
      {!loading && <LoadingIcon />}
      <div style={{ maxWidth: '100%' }}>
        <Container maxWidth="xl" style={{ marginTop: '5px', marginBottom: '5px', padding: '20px' }}>
          <Grid container spacing={3}>
            <Grid xs={4} item container justifyContent="flex-start" alignContent="center">
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                  className={classes.formControl}
                  value={startDate}
                  onChange={(e) => handleStartDate(e)}
                  label="Select start date"
                  format="MM/dd/yyyy"
                  margin="normal"
                  id="date-picker-start"
                />
                <KeyboardDatePicker
                  className={classes.formControl}
                  value={endDate}
                  onChange={(e) => handleEndDate(e)}
                  label="Select end date"
                  format="MM/dd/yyyy"
                  margin="normal"
                  id="date-picker-end"
                />
              </MuiPickersUtilsProvider>
            </Grid>
            <Grid xs={8} item container alignItems="center">
              <Grid
                lg={3}
                item
                container
                justifyContent="flex-start"
                style={{ marginRight: '20px' }}
              >
                <RadioGroup
                  name="bg_radio"
                  style={{ height: '100%' }}
                  onChange={(e) => {
                    setRadio(e.target.value);
                    setgroupV([]);
                  }}
                >
                  <FormControlLabel
                    style={{ margin: 0 }}
                    value="a"
                    control={<Radio />}
                    label="TCN"
                    checked={radio == 'a'}
                  />
                  {/* <FormControlLabel
                    style={{ margin: 0 }}
                    value="g"
                    control={<Radio />}
                    label="Client"
                    checked={radio == 'g'}
                  /> */}
                </RadioGroup>
              </Grid>
              <Grid container item xs={6} alignItems="center" justifyContent="flex-start">
                <Grid container item xs={12} alignItems="center" justifyContent="center">
                  {radio == 'a' && (
                    <TextField variant="outlined" label="All Machines" fullWidth disabled />
                  )}

                  {radio == 'g' && (
                    <Autocomplete
                      value={groupV}
                      options={groups}
                      disableCloseOnSelect
                      onChange={(event, value) => {
                        setgroupV(value);
                      }}
                      getOptionSelected={(option, value) => option._id === value._id}
                      getOptionLabel={(option) => option.groupname}
                      renderOption={(option, { selected }) => (
                        <React.Fragment>
                          <Checkbox
                            icon={icon}
                            checkedIcon={checkedIcon}
                            style={{ marginRight: 8 }}
                            checked={selected}
                          />
                          {option.groupname}
                        </React.Fragment>
                      )}
                      fullWidth
                      renderInput={(params) => (
                        <TextField {...params} variant="outlined" label="Groups" />
                      )}
                    />
                  )}
                </Grid>
              </Grid>

              <Grid item xs={1} style={{ marginLeft: '15px' }}>
                <Button
                  style={{ height: '40px' }}
                  onClick={handleSearch}
                  variant="contained"
                  color="primary"
                >
                  Submit
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Container>
        {/* </Box> */}
        <MaterialTable
          // onChangeRowsPerPage={setPagination}
          title={'Download Sales'}
          columns={columns}
          data={order}
          options={{
            exportButton: {
              csv: true,
            },
            exportAllData: true,
            actionsColumnIndex: -1,
            pageSize: 100,
            pageSizeOptions: [10, 20, 50, 100, 200],
            rowStyle: (rowData) => {},
          }}
          actions={[]}
          editable={{
            onRowUpdate: (newData, oldData) =>
              new Promise((resolve, reject) => {
                setTimeout(() => {
                  handleRowUpdate(newData, oldData);
                  resolve();
                }, 1000);
              }),
          }}
        />
        <BackButton />
      </div>
    </div>
  );
}
